var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81329 4.18499C10.0618 4.43163 10.0618 4.83153 9.81329 5.07817L6.86933 8L9.81329 10.9218C10.0618 11.1685 10.0618 11.5684 9.81329 11.815C9.56477 12.0617 9.16185 12.0617 8.91333 11.815L5.51939 8.44659C5.27088 8.19995 5.27088 7.80005 5.51939 7.55341L8.91333 4.18499C9.16185 3.93834 9.56477 3.93834 9.81329 4.18499Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/caret-left.5815e5ffc9f280179dadd140c2be9526.svg";
export { ForwardRef as ReactComponent };